import React, { useState } from 'react';
import { Button } from 'antd';
import ConfirmModal from '../ConfirmModal';
import styles from './index.module.scss';
import type { ConfirmModalOtherProps } from '../ConfirmModal';

type UpdateThemeBtnProps = {
  isOfficial: boolean;
  isColorPicked: boolean;
  resetTheme: () => void;
  updateTheme: () => void;
  deleteTheme: () => void;
  confirmModalOtherProps: ConfirmModalOtherProps;
};

const ThemeControlBtns = ({
  isOfficial,
  isColorPicked,
  resetTheme,
  updateTheme,
  deleteTheme,
  confirmModalOtherProps,
}: UpdateThemeBtnProps) => {
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  return (
    <div className={styles.updateBtnsContainer}>
      <div className={styles.saveBtn}>
        <Button
          type="primary"
          disabled={isOfficial}
          onClick={() => setIsUpdateModalOpen(true)}
        >
          儲存目前設定
        </Button>
        <ConfirmModal
          action="update"
          title="要修改主題設定嗎？"
          content="確定修改當前主題，請按確定鍵。"
          open={isUpdateModalOpen}
          confirmModalOtherProps={confirmModalOtherProps}
          confirmCallback={updateTheme}
          setModalClose={() => setIsUpdateModalOpen(false)}
        />
      </div>
      <div className={styles.resetBtn}>
        <Button
          type="primary"
          disabled={isOfficial === true && isColorPicked === false}
          onClick={resetTheme}
        >
          清除目前設定
        </Button>
      </div>
      <div className={styles.deleteThemeBtn}>
        <Button
          type="primary"
          disabled={isOfficial}
          onClick={() => setIsDeleteModalOpen(true)}
        >
          刪除當前主題
        </Button>
        <ConfirmModal
          action="delete"
          title="確定要刪除當前主題嗎？"
          content="刪除請按確定鍵。"
          open={isDeleteModalOpen}
          confirmCallback={deleteTheme}
          confirmModalOtherProps={confirmModalOtherProps}
          setModalClose={() => setIsDeleteModalOpen(false)}
        />
      </div>
    </div>
  );
};

export default ThemeControlBtns;
